import { useState } from 'react'

export default function useCheck() {
  const [check, setCheck] = useState(false)

  const toggleCheck = () => setCheck(!check)

  return [check, toggleCheck]
}
